"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restrictOrbitControls = void 0;
var _pick = _interopRequireDefault(require("lodash/pick"));
var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var stateMemo = function stateMemo(obj, props) {
  var state = (0, _pick["default"])(obj, props);
  return function () {
    Object.assign(obj, state);
  };
};
var restrictOrbitControls = exports.restrictOrbitControls = function restrictOrbitControls(orbitControls) {
  if (!(orbitControls instanceof _OrbitControls.OrbitControls)) {
    throw new Error("restrictOrbitControls can handle only the OrbitControls object type");
  }
  var restoreInitialState = stateMemo(orbitControls, ["minPolarAngle", "maxPolarAngle", "minAzimuthAngle", "maxAzimuthAngle"]);
  var byAngle = function byAngle(angleRad) {
    var currentPolarAngle = orbitControls.getPolarAngle();
    var currentAzimuthAngle = orbitControls.getAzimuthalAngle();
    Object.assign(orbitControls, {
      minPolarAngle: currentPolarAngle - angleRad,
      maxPolarAngle: currentPolarAngle + angleRad,
      minAzimuthAngle: currentAzimuthAngle - angleRad,
      maxAzimuthAngle: currentAzimuthAngle + angleRad
    });
    return restoreInitialState;
  };
  return {
    byAngle: byAngle
  };
};